
  import { ComponentInstance, defineComponent, onMounted, ref } from 'vue';
  import { TooltipPositions, TooltipSizes } from '@/ui/components/Tooltip';

  interface TooltipProps {
    label?: string;
    position?: TooltipPositions;
    multilined?: boolean;
    classes?: string;
    size?: TooltipSizes;
    appendToBody?: boolean;
    contentClass?: string;
  }

  export default defineComponent<TooltipProps>({
    name: 'Tooltip',
    props: ['label', 'position', 'multilined', 'classes', 'size', 'appendToBody', 'contentClass'],
    setup() {
      const tooltipRef = ref<ComponentInstance | null>(null);
      const active = ref(false);

      onMounted(() => {
        const element = tooltipRef.value?.$el?.querySelector('.tooltip-trigger > *') as HTMLElement;

        if (!element) {
          return;
        }

        if (element.offsetHeight < element.scrollHeight) {
          active.value = true;
        }
      });

      return {
        tooltipRef,
        active,
      };
    },
  });
